import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import PlanPanel from 'modules/billing/components/PlanPanel'

interface Props {
  onCTAClick: () => void | Promise<void>
  planLabel: string
}

export const LegacyPlan = ({ onCTAClick, planLabel }: Props) => {
  return (
    <Box>
      <Box>
        <Box gap="s12">
          <Icon.Large icon="multiple-buildings" color="radicalRed1000" />
          <Text.Header2 color="grey1000" weight="semibold">
            {i18n.t('billing.your_recruitment_plan.title')}
          </Text.Header2>
          <Text.Normal color="grey800">
            {i18n.t('billing.your_recruitment_plan.description')}
          </Text.Normal>
        </Box>

        <Button type="primary" onClick={onCTAClick}>
          {i18n.t('billing.your_recruitment_plan.update_plan')}
        </Button>
      </Box>
      <PlanPanel.Container title="Recruitment">
        <PlanPanel.Row label={i18n.t('billing.bill.ats')}>{planLabel}</PlanPanel.Row>
      </PlanPanel.Container>
    </Box>
  )
}
